const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>نام کشاورز</span>
      </div>
    ),
    accessorKey: "farmer_name",
    enableColumnFilter: true,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>
          قیمت هر یونیت{" "}
          <span className="text-blue-600 text-[10px]">(تومان)</span>
        </span>
      </div>
    ),
    accessorKey: "price",
    enableColumnFilter: true,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>
           قیمت کل {" "}
          <span className="text-blue-600 text-[10px]">(تومان)</span>
        </span>
      </div>
    ),
    accessorKey: "total_price",
    enableColumnFilter: true,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>نام کارخانه</span>
      </div>
    ),

    accessorKey: "factory_name",
    enableColumnFilter: true,
  },

  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>شماره تعهد</span>
      </div>
    ),
    accessorKey: "commitment_number",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>نام بذر</span>
      </div>
    ),
    accessorKey: "seed_name",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span> تعداد</span>
      </div>
    ),
    accessorKey: "seed_amount",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: "تاریخ ثبت",
    accessorKey: "created_at",
    enableColumnFilter: false,
  },
];

export default columnData;
